export default function getEnvValue(name: string) {
  if (name === 'NODE_ENV') {
    return import.meta.env.MODE;
  }
  return (import.meta.env[name] || '').toString().trim();
}
